<template>
    <div class="Modelo145">
        <div v-if="modelData.permitirModificacionDatos == 1" class="row">
            <div class="col align-right mb-2">
                <a href="#" class="btn-dashed waves-effect" @click.prevent="edit()">
                    <i class="ms-Icon ms-Icon--Add"></i> {{ $t('notificarModificacion') }}
                </a>
            </div>
        </div>
        <div v-if="modelData.noHayInformadoModelo == 1">
            <div class="card mb-3">
                <div class="body">
                    <strong>{{ $t('noInformadoModeloTitle') }}</strong>
                    <br>
                    <br>
                    {{ $t('noInformadoModelo') }}
                </div>
            </div>            
            <br>            
        </div>
        <div v-else-if="loaded">
            <div class="card mb-3">
                <div class="body">
                    <span>{{ $t('datosIdentificativos') }}</span>
                    <br>
                    <br>
                    <div class="row clearfix">
                        <div class="col-md-4 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('NIF') }}</span></small>
                            <p>{{nif}}</p>
                        </div>

                        <div class="col-md-4 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('apellidosNombre') }}</span></small>
                            <p>{{primerApellido}} {{segundoApellido}} {{nombre}}</p>
                        </div>

                        <div class="col-md-4 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('añoNacimiento') }}:</span></small>
                            <p>{{fecNacimiento}}</p>
                        </div>
                    </div>
                    <br>
                    <div>
                        <small class="text-muted">
                            <span>{{ $t('situacionFamiliar') }}:</span></small>
                        <p><strong>{{ $t('situacionFamiliar') }} {{modelData.situacionFamiliar+1}}. </strong>
                            <span v-if="modelData.situacionFamiliar == 0">{{ $t('situacionFamiliar0') }}</span>
                            <span v-if="modelData.situacionFamiliar == 1">{{ $t('situacionFamiliar1') }}</span>
                            <span v-if="modelData.situacionFamiliar == 2">{{ $t('situacionFamiliar2') }}</span>
                        </p>
                    </div>
                    <br>
                    <div class="row clearfix">
                        <div class="col-md-2 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('discapacidad') }}</span></small>
                            <p v-if="modelData.discapContribuyente == 0">{{ $t('gradoDiscapacidad0') }}</p>
                            <p v-if="modelData.discapContribuyente == 1">{{ $t('gradoDiscapacidad1') }}</p>
                            <p v-if="modelData.discapContribuyente == 2">{{ $t('gradoDiscapacidad2') }}</p>
                        </div>

                        <div class="col-md-2 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('ayuda') }}:</span></small>
                            <p v-if="modelData.conNecesidadAyuda == 1">{{ $t('si') }}</p>
                            <p v-else>{{ $t('no') }}</p>
                        </div>

                        <div class="col-md-6 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('movGeografica') }}:</span></small>
                            <p v-if="modelData.fechaMovilidadGeografica != '01/01/1753'">
                                {{modelData.fechaMovilidadGeografica}}</p>
                            <p v-if="modelData.fechaMovilidadGeografica == '01/01/1753'">{{ $t('sinInformar') }}</p>
                        </div>

                        <div class="col-md-2 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('rendimientos') }}</span></small>
                            <p v-if="modelData.rdtos2Anos5Anteriores == 1">{{ $t('si') }}</p>
                            <p v-else>{{ $t('no') }}</p>
                        </div>
                    </div>
                    <div>
                        <small class="text-muted">
                            <span>{{ $t('pagosAdquisicionVivienda') }}</span></small>
                        <p v-if="modelData.pagosAdquisViviendas == 1">{{ $t('si') }}</p>
                        <p v-else>{{ $t('no') }}</p>
                    </div>
                </div>
            </div>
            <div class="card mb-3">
                <div class="body">
                    <span>{{ $t('pensiones') }}</span>
                    <br>
                    <br>
                    <div class="row clearfix">
                        <div class="col-md-4 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('pensionConyuge') }}</span></small>
                            <p>{{parseFloat(modelData.rentasConyuge).toFixed(2)}} €</p>
                        </div>

                        <div class="col-md-8 col-xs-12">
                            <small class="text-muted">
                                <span>{{ $t('anualidadesAlimentos') }}</span></small>
                            <p>{{parseFloat(modelData.rentasDescendientes).toFixed(2)}} €</p>
                        </div>
                    </div>
                </div>
            </div>
            <div class="card mb-0">
                <div class="body">
                    <div class="row clearfix">
                        <div class="col-md-6 col-xs-12">
                            <span>{{ $t('descendientes') }}</span>
                            <div v-if="descendientes.length > 0">
                                <table class="table table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th>{{this.$i18n.t('añoNacimiento') }}</th>
                                            <th>{{this.$i18n.t('añoAdopcion') }}</th>
                                            <th>{{this.$i18n.t('gradoDiscapacidad')}}</th>
                                            <th>{{this.$i18n.t('ayuda')}}</th>
                                            <th>{{this.$i18n.t('computoEntero')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(descendiente, index) in descendientes" :key="index">
                                            <td><span>{{ descendiente.anoNacimiento }}</span></td>
                                            <td><span>{{ descendiente.anoAdopcion }}</span></td>
                                            <td>
                                                <span v-if="descendiente.tipoDiscapacidad == 0">{{
                                                    $t('gradoDiscapacidad0') }}</span>
                                                <span v-if="descendiente.tipoDiscapacidad == 1">{{
                                                    $t('gradoDiscapacidad1') }}</span>
                                                <span v-if="descendiente.tipoDiscapacidad == 2">{{
                                                    $t('gradoDiscapacidad2') }}</span>
                                            </td>
                                            <td>
                                                <span v-if="descendiente.movilidadReducida == 1">{{ $t('si') }}</span>
                                                <span v-else>{{ $t('no') }}</span>
                                            </td>
                                            <td>
                                                <span v-if="descendiente.tipoComputo == 1">{{ $t('si') }}</span>
                                                <span v-else>{{ $t('no') }}</span>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else>
                                <small class="text-muted"><span>{{ this.$i18n.t('noExistenDescendientes')
                                        }}</span></small>
                            </div>
                        </div>
                        <div class="col-md-6 col-xs-12">
                            <span>{{ $t('ascendientes') }}</span>
                            <div v-if="ascendientes.length > 0">
                                <table class="table table-striped table-bordered">
                                    <thead>
                                        <tr>
                                            <th>{{this.$i18n.t('añoNacimiento') }}</th>
                                            <th>{{this.$i18n.t('gradoDiscapacidad')}}</th>
                                            <th>{{this.$i18n.t('ayuda')}}</th>
                                            <th>{{this.$i18n.t('numDescConv')}}</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        <tr v-for="(ascendiente, index) in ascendientes" :key="index">
                                            <td><span>{{ ascendiente.anoNacimiento }}</span></td>
                                            <td>
                                                <span v-if="ascendiente.tipoDiscapacidad == 0">{{
                                                    $t('gradoDiscapacidad0') }}</span>
                                                <span v-if="ascendiente.tipoDiscapacidad == 1">{{
                                                    $t('gradoDiscapacidad1') }}</span>
                                                <span v-if="ascendiente.tipoDiscapacidad == 2">{{
                                                    $t('gradoDiscapacidad2') }}</span>
                                            </td>
                                            <td>
                                                <span v-if="ascendiente.movilidadReducida == 1">{{ $t('si') }}</span>
                                                <span v-else>{{ $t('no') }}</span>
                                            </td>
                                            <td><span>{{ ascendiente.numPersonasConvivenc }}</span></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                            <div v-else>
                                <small class="text-muted"><span>{{ this.$i18n.t('noExistenAscendientes')
                                        }}</span></small>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
#FotoUsuario {
    width: 170px;
}
</style>

<script>
import { modelService } from '@/api/model';
import { employeeService } from '@/api/employee';

export default {
    name: 'Modelo145',    
    data(){
        return {
            loaded: false,
            nif: "",
            primerApellido: "",
            segundoApellido: "",
            nombre: "",
            fecNacimiento: "",
            modelData: [],
            descendientes: [],
            ascendientes: [],
            fieldsDescendientes: [
                {
                    key: 'anoNacimiento',
                    sortable: false,
                    label:  this.$i18n.t('añoNacimiento') 
                },
                {
                    key: 'anoAdopcion',
                    sortable: false,
                    label: this.$i18n.t('añoAdopcion') 
                },
                {
                    key: 'gradoDiscapacidad',
                    label: this.$i18n.t('gradoDiscapacidad') ,
                    sortable: false,
                },
                {
                    key: 'movilidadReducida',
                    label: this.$i18n.t('ayuda') ,
                    sortable: false,
                },
                {
                    key: 'tipoComputo',
                    label: this.$i18n.t('computoEntero') ,
                    sortable: false,
                }
            ],
            fieldsAscendientes: [
                {
                    key: 'anoNacimiento',
                    sortable: false,
                    label:  this.$i18n.t('añoNacimiento') 
                },
                {
                    key: 'gradoDiscapacidad',
                    label: this.$i18n.t('gradoDiscapacidad') ,
                    sortable: false,
                },
                {
                    key: 'movilidadReducida',
                    label: this.$i18n.t('ayuda') ,
                    sortable: false,
                },
                {
                    key: 'numPersonasConvivenc',
                    label: this.$i18n.t('numDescConv') ,
                    sortable: false,
                }
            ]
        }
    },
    async mounted () {

        let dataEmployee = await employeeService.getDataEmployee();
        this.nif = dataEmployee.nif;
        this.primerApellido = dataEmployee.primerApellido;
        this.segundoApellido = dataEmployee.segundoApellido;
        this.nombre = dataEmployee.nombre;
        this.fecNacimiento = dataEmployee.fecNacimiento;
        
        let modelData = await modelService.getModelData();
        this.modelData = modelData;
        if (modelData != null && modelData != []){
            
                var year = (modelData.anoEjercicio == null) ? new Date().getFullYear() : modelData.anoEjercicio;
                let descendientes = await modelService.getDescendienteData(year);
                this.descendientes = descendientes;
                let ascendientes = await modelService.getAscendienteData(year);
                this.ascendientes = ascendientes;

        }
        this.loaded = true;
    },
    methods: {
        edit() {
            for (let i = this.ascendientes.length; i < 2; i++){
                this.ascendientes.push({anoNacimiento: '', tipoDiscapacidad: 0, movilidadReducida: 0, numPersonasConvivenc: 0});
            }
            for (let i = this.descendientes.length; i < 5; i++){
                this.descendientes.push({anoNacimiento: '', anoAdopcion: '', tipoDiscapacidad: 0, movilidadReducida: 0, tipoComputo: 0});
            }
            
            this.$router.push({
                name: 'model145-edit',
                params: {
                    ascendientesProp: this.ascendientes,
                    descendientesProp: this.descendientes,
                    nifProp: this.nif,
                    primerApellidoProp: this.primerApellido,
                    segundoApellidoProp: this.segundoApellido,
                    fecNacimientoProp: this.fecNacimiento,
                    nombreProp: this.nombre
                }
            });
        },
    }
}
</script> 